const Countries = [
  {
    id: 1,
    value: "us",
    label: "United States",
    emoji: "🇺🇸",
    continent: "North America",
  },
  { id: 2, value: "in", label: "India", emoji: "🇮🇳", continent: "Asia" },
  { id: 3, value: "cn", label: "China", emoji: "🇨🇳", continent: "Asia" },
  {
    id: 4,
    value: "br",
    label: "Brazil",
    emoji: "🇧🇷",
    continent: "South America",
  },
  { id: 5, value: "id", label: "Indonesia", emoji: "🇮🇩", continent: "Asia" },
  { id: 6, value: "pk", label: "Pakistan", emoji: "🇵🇰", continent: "Asia" },
  { id: 7, value: "ng", label: "Nigeria", emoji: "🇳🇬", continent: "Africa" },
  { id: 8, value: "bd", label: "Bangladesh", emoji: "🇧🇩", continent: "Asia" },
  {
    id: 9,
    value: "ru",
    label: "Russia",
    emoji: "🇷🇺",
    continent: "Europe/Asia",
  },
  {
    id: 10,
    value: "mx",
    label: "Mexico",
    emoji: "🇲🇽",
    continent: "North America",
  },
  { id: 11, value: "jp", label: "Japan", emoji: "🇯🇵", continent: "Asia" },
  { id: 12, value: "et", label: "Ethiopia", emoji: "🇪🇹", continent: "Africa" },
  { id: 13, value: "ph", label: "Philippines", emoji: "🇵🇭", continent: "Asia" },
  { id: 14, value: "eg", label: "Egypt", emoji: "🇪🇬", continent: "Africa" },
  { id: 15, value: "vn", label: "Vietnam", emoji: "🇻🇳", continent: "Asia" },
  { id: 16, value: "cd", label: "DR Congo", emoji: "🇨🇩", continent: "Africa" },
  {
    id: 17,
    value: "tr",
    label: "Turkey",
    emoji: "🇹🇷",
    continent: "Asia/Europe",
  },
  { id: 18, value: "ir", label: "Iran", emoji: "🇮🇷", continent: "Asia" },
  { id: 19, value: "de", label: "Germany", emoji: "🇩🇪", continent: "Europe" },
  { id: 20, value: "th", label: "Thailand", emoji: "🇹🇭", continent: "Asia" },
  {
    id: 21,
    value: "gb",
    label: "United Kingdom",
    emoji: "🇬🇧",
    continent: "Europe",
  },
  { id: 22, value: "fr", label: "France", emoji: "🇫🇷", continent: "Europe" },
  { id: 23, value: "it", label: "Italy", emoji: "🇮🇹", continent: "Europe" },
  {
    id: 24,
    value: "za",
    label: "South Africa",
    emoji: "🇿🇦",
    continent: "Africa",
  },
  { id: 25, value: "kr", label: "South Korea", emoji: "🇰🇷", continent: "Asia" },
  {
    id: 26,
    value: "co",
    label: "Colombia",
    emoji: "🇨🇴",
    continent: "South America",
  },
  { id: 27, value: "es", label: "Spain", emoji: "🇪🇸", continent: "Europe" },
  {
    id: 28,
    value: "ar",
    label: "Argentina",
    emoji: "🇦🇷",
    continent: "South America",
  },
  {
    id: 29,
    value: "ca",
    label: "Canada",
    emoji: "🇨🇦",
    continent: "North America",
  },
  {
    id: 30,
    value: "sa",
    label: "Saudi Arabia",
    emoji: "🇸🇦",
    continent: "Asia",
  },
  {
    id: 31,
    value: "au",
    label: "Australia",
    emoji: "🇦🇺",
    continent: "Oceania",
  },
  {
    id: 32,
    value: "pe",
    label: "Peru",
    emoji: "🇵🇪",
    continent: "South America",
  },
  { id: 33, value: "my", label: "Malaysia", emoji: "🇲🇾", continent: "Asia" },
  {
    id: 34,
    value: "nl",
    label: "Netherlands",
    emoji: "🇳🇱",
    continent: "Europe",
  },
  {
    id: 35,
    value: "ch",
    label: "Switzerland",
    emoji: "🇨🇭",
    continent: "Europe",
  },
  { id: 36, value: "be", label: "Belgium", emoji: "🇧🇪", continent: "Europe" },
  { id: 37, value: "se", label: "Sweden", emoji: "🇸🇪", continent: "Europe" },
  { id: 38, value: "pl", label: "Poland", emoji: "🇵🇱", continent: "Europe" },
  { id: 39, value: "ua", label: "Ukraine", emoji: "🇺🇦", continent: "Europe" },
  { id: 40, value: "ma", label: "Morocco", emoji: "🇲🇦", continent: "Africa" },
  { id: 41, value: "ro", label: "Romania", emoji: "🇷🇴", continent: "Europe" },
  { id: 42, value: "kz", label: "Kazakhstan", emoji: "🇰🇿", continent: "Asia" },
  {
    id: 43,
    value: "cl",
    label: "Chile",
    emoji: "🇨🇱",
    continent: "South America",
  },
  {
    id: 44,
    value: "nz",
    label: "New Zealand",
    emoji: "🇳🇿",
    continent: "Oceania",
  },
  { id: 45, value: "dz", label: "Algeria", emoji: "🇩🇿", continent: "Africa" },
  { id: 46, value: "at", label: "Austria", emoji: "🇦🇹", continent: "Europe" },
  {
    id: 47,
    value: "ae",
    label: "United Arab Emirates",
    emoji: "🇦🇪",
    continent: "Asia",
  },
  {
    id: 48,
    value: "cz",
    label: "Czech Republic",
    emoji: "🇨🇿",
    continent: "Europe",
  },
  { id: 49, value: "gr", label: "Greece", emoji: "🇬🇷", continent: "Europe" },
  { id: 50, value: "pt", label: "Portugal", emoji: "🇵🇹", continent: "Europe" },
];

export default Countries;
